<template>
    <div>
        <!-- Main Edit Modal -->
        <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper" @click="$emit('closeModal')">
                    <div class="modal-container" @click.stop>
                        <!-- Header -->
                        <div class="modal-header-custom d-flex justify-content-between align-items-center">
                            <div class="d-flex align-items-center">
                                <img 
                                    src="@/assets/img/svg/arrow-left.svg" 
                                    alt="Back" 
                                    class="back-icon mr-2" 
                                    @click="$emit('closeModal')" 
                                />
                                <h5 class="modal-title-custom mb-0">Edit Pengiriman Satuan</h5>
                            </div>
                            <button class="btn btn-close-custom" @click="$emit('closeModal')">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>

                        <!-- Body -->
                        <div class="modal-body-custom">
                            <!-- Dealer Tujuan -->
                            <div class="modal-form-row">
                                <label class="modal-form-label mb-0">Dealer Tujuan</label>
                                <div class="modal-form-input">
                                    <Multiselect
                                        v-model="kode_dealer"
                                        :options="dealerCodeOptions"
                                        :custom-label="getDealerLabel"
                                        placeholder="Select Dealer"
                                        :show-labels="false"
                                        :searchable="true"
                                        :allow-empty="false"
                                        class="custom-modal-select"
                                    />
                                </div>
                            </div>

                            <!-- Jumlah QR -->
                            <div class="modal-form-row">
                                <label class="modal-form-label mb-0">Jumlah QR</label>
                                <div class="modal-form-input">
                                    <input
                                        type="number"
                                        class="form-control modal-input"
                                        v-model.number="qty"
                                        placeholder="Jumlah QR"
                                        min="0"
                                    />
                                </div>
                            </div>

                            <!-- Tanda Tangan -->
                            <div class="modal-form-row align-top">
                                <label class="modal-form-label mb-0 pt-2">Tanda Tangan</label>
                                <div class="modal-form-input">
                                    <div class="signature-box">
                                        <vue-signature-pad width="100%" height="130px" ref="signaturePad" />
                                        <button
                                            type="button"
                                            class="btn-clear-signature"
                                            @click="$refs.signaturePad.clearSignature()"
                                        >
                                            Hapus
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Actions -->
                            <div class="modal-actions-row d-flex justify-content-end align-items-center">
                                <button 
                                    type="button" 
                                    class="btn btn-batal" 
                                    @click="$emit('closeModal')"
                                >
                                    Batal
                                </button>
                                <button 
                                    type="button" 
                                    class="btn btn-kirim" 
                                    @click="handleKirimClick"
                                >
                                    Kirim
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

        <confirm-pengiriman-modal
            :show="showConfirmModal"
            :qty="qty"
            :dealer-label="getDealerLabel(kode_dealer)"
            :is-submitting="isSubmitting"
            @cancel="showConfirmModal = false"
            @confirm="confirmAndSend"
        />
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import ConfirmPengirimanModal from './ConfirmPengirimanModal.vue';

export default {
    components: {
        Multiselect,
        ConfirmPengirimanModal
    },
    data() {
        return {
            id: '',
            package_code: '',
            kode_dealer: '',
            qty: 0,
            sender_signature: null,
            showConfirmModal: false,
            isSubmitting: false
        }
    },
    computed: {
        dealerData() {
            if (this.$store.getters && this.$store.getters.getDealer) {
                const list = this.$store.getters.getDealer();
                if (list && list.length) return list;
            }
            return this.$store.state.filterOptions.dealer || [];
        },
        dealerCodeOptions() {
            const codes = this.dealerData.map(x => x.code).filter(Boolean);
            if (this.kode_dealer && !codes.includes(this.kode_dealer)) {
                return [this.kode_dealer, ...codes];
            }
            return codes;
        }
    },
    mounted() {
        this.showData();
    },
    methods: {
        getDealerLabel(code) {
            if (!code) return '';
            const dealer = this.dealerData.find(x => x.code === code);
            if (dealer) {
                if (dealer.name) {
                    return dealer.name.includes(dealer.code) ? dealer.name : `${dealer.code} - ${dealer.name}`;
                }
                return dealer.code;
            }
            return code;
        },
        resetBody() {
            this.package_code = '';
            this.kode_dealer = '';
            this.qty = 0;
            this.showConfirmModal = false;
            this.isSubmitting = false;
            if (this.$refs.signaturePad) {
                this.$refs.signaturePad.clearSignature();
            }
        },
        showData() {
            if (!this.$parent || !this.$parent.dataEdit) return;
            this.id = this.$parent.dataEdit.id;
            this.package_code = this.$parent.dataEdit.package_code || '';
            this.kode_dealer = this.$parent.dataEdit.kode_dealer || '';
            this.qty = this.$parent.dataEdit.qty || 0;
            try {
                if (this.$parent.dataEdit.sender_signature) {
                    const image = new Image();
                    image.src = this.$parent.dataEdit.sender_signature;
                    image.onload = () => {
                        const canvas = document.createElement('canvas');
                        canvas.width = image.width;
                        canvas.height = image.height;
                        const ctx = canvas.getContext('2d');
                        ctx.drawImage(image, 0, 0);
                        canvas.toBlob(blob => {
                            if (this.$refs.signaturePad) {
                                this.$refs.signaturePad.fromDataURL(URL.createObjectURL(blob));
                            }
                        }, 'image/png', 1);
                    };
                }
            } catch (err) {
                console.log(err);
            }
        },
        handleKirimClick() {
            let errors = [];
            if (!this.kode_dealer) {
                errors.push('Dealer Tujuan wajib dipilih');
            }
            if (!this.qty || this.qty <= 0) {
                errors.push('Jumlah QR tidak boleh 0');
            }

            if (this.$refs.signaturePad) {
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                if (isEmpty) {
                    errors.push('Tanda tangan wajib diisi');
                } else {
                    this.sender_signature = data.split(",")[1];
                }
            } else if (!this.sender_signature) {
                errors.push('Tanda tangan wajib diisi');
            }

            if (errors.length > 0) {
                this.$swal.fire({
                    title: "Error",
                    html: `<p>> ${errors.join("<br>> ")}</p>`,
                    icon: "error",
                });
                return;
            }

            // Open confirmation modal
            this.showConfirmModal = true;
        },
        async confirmAndSend() {
            try {
                this.isSubmitting = true;
                let datasend = {
                    kode_dealer: this.kode_dealer,
                    qty: this.qty,
                    sender_signature: this.sender_signature
                };

                await this.$http.put('/api/qrs/issue/' + this.id, datasend);

                this.showConfirmModal = false;
                this.$emit('updateTable');
                this.resetBody();
            } catch (err) {
                console.log(err);
                this.$swal.fire({
                    title: "Error",
                    text: err.response && err.response.data && err.response.data.message ? err.response.data.message : (err.message || "Gagal mengubah pengiriman"),
                    icon: "error"
                });
            } finally {
                this.isSubmitting = false;
            }
        }
    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 1050;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.3s ease;
    padding: 20px;
}

.modal-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.modal-container {
    width: 521px;
    max-width: 521px;
    min-height: 357px;
    background-color: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    padding: 0;
    overflow: hidden;
    transform: rotate(0deg);
    opacity: 1;
}

.modal-header-custom {
    padding: 16px 20px;
    border-bottom: 1px solid #F3F4F6;
}

.back-icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
    object-fit: contain;
}

.modal-title-custom {
    font-size: 15px;
    font-weight: 600;
    color: #111827;
}

.btn-close-custom {
    padding: 0;
    border: none;
    background: transparent;
    color: #111827;
    font-size: 18px;
    cursor: pointer;
    line-height: 1;
}

.btn-close-custom:hover {
    color: #6B7280;
}

.modal-body-custom {
    padding: 20px 24px 24px 24px;
}

.modal-form-row {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
}

.modal-form-row.align-top {
    align-items: flex-start;
}

.modal-form-label {
    width: 130px;
    flex-shrink: 0;
    font-size: 14px;
    font-weight: 600;
    color: #2F2F2F;
}

.modal-form-input {
    flex: 1;
    min-width: 0;
}

.modal-input {
    height: 38px;
    border: 1px solid #E5E7EB;
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 14px;
    color: #2F2F2F;
    background-color: #FFFFFF;
    box-shadow: none;
    outline: none;
    width: 100%;
}

.modal-input:focus {
    border-color: #F36F21;
    box-shadow: 0 0 0 1px #F36F21;
}

.signature-box {
    border: 1px solid #E5E7EB;
    border-radius: 6px;
    position: relative;
    background: #FFFFFF;
    overflow: hidden;
    height: 130px;
}

.btn-clear-signature {
    position: absolute;
    bottom: 8px;
    right: 12px;
    background: transparent;
    border: none;
    color: #ADADAD;
    font-size: 13px;
    cursor: pointer;
    padding: 2px 6px;
    outline: none;
}

.btn-clear-signature:hover {
    color: #6B7280;
}

.modal-actions-row {
    margin-top: 24px;
}

.btn-batal {
    background: transparent;
    border: none;
    color: #F36F21;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    margin-right: 8px;
    box-shadow: none;
    cursor: pointer;
}

.btn-batal:hover {
    color: #D95D16;
    background: transparent;
}

.btn-kirim {
    background-color: #F36F21;
    border: 1px solid #F36F21;
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 500;
    border-radius: 6px;
    padding: 8px 28px;
    box-shadow: none;
    cursor: pointer;
    transition: background-color 0.2s;
}

.btn-kirim:hover {
    background-color: #D95D16;
    border-color: #D95D16;
    color: #FFFFFF;
}

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
}
</style>

<style>
/* Multiselect overrides inside modal */
.custom-modal-select.multiselect {
    min-height: 38px;
    font-size: 14px;
}

.custom-modal-select .multiselect__tags {
    min-height: 38px;
    height: 38px;
    padding: 8px 36px 0 12px;
    border: 1px solid #E5E7EB;
    border-radius: 6px;
    background: #FFFFFF;
}

.custom-modal-select .multiselect__single {
    margin-bottom: 0;
    padding-left: 0;
    font-size: 14px;
    color: #2F2F2F;
    line-height: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.custom-modal-select .multiselect__select {
    height: 38px;
    width: 36px;
    padding: 4px 8px;
}

.custom-modal-select .multiselect__select::before {
    border-color: #2F2F2F transparent transparent;
    border-width: 5px 4px 0 4px;
}

.custom-modal-select .multiselect__placeholder {
    margin-bottom: 0;
    padding-top: 0;
    font-size: 14px;
    color: #9CA3AF;
    line-height: 20px;
}

.custom-modal-select .multiselect__input {
    font-size: 14px;
    margin-bottom: 0;
    padding-left: 0;
    line-height: 20px;
}

.custom-modal-select .multiselect__content-wrapper {
    border: 1px solid #E5E7EB;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    font-size: 14px;
    max-height: 200px;
}
</style>